webpackJsonp([35783957827783,122595392396565,67272453473844,195873343377762,164130687611750,86789758835214],{

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _path = __webpack_require__(23);
	
	var _path2 = _interopRequireDefault(_path);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlogBlock = function (_React$Component) {
	  _inherits(BlogBlock, _React$Component);
	
	  function BlogBlock(graphql) {
	    _classCallCheck(this, BlogBlock);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this));
	  }
	
	  BlogBlock.prototype.render = function render() {
	    if (!this.props.data) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        ' no data '
	      );
	    }
	    var data = this.props.data;
	    return _react2.default.createElement(
	      'div',
	      { style: {
	          margin: '0 auto',
	          maxWidth: 1100,
	          padding: '0px 1.0875rem 1.45rem',
	          paddingTop: 0
	        }, id: 'Blog' },
	      _react2.default.createElement(
	        'h2',
	        { style: { textAlign: 'center' } },
	        ' Blog '
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: 'blog-post', style: { margin: 0 } },
	        data.allMarkdownRemark.edges.reverse().filter(function (post) {
	          return post.node.frontmatter.type == "blog";
	        }).map(function (post) {
	          var image = post.node.frontmatter.image ? post.node.frontmatter.image.childImageSharp.responsiveSizes.src : '',
	              title = post.node.frontmatter.title,
	              path = post.node.frontmatter.path,
	              description = post.node.frontmatter.description,
	              draft = post.node.frontmatter.draft == "true" ? true : false,
	              firstParagraph = post.node.frontmatter.firstParagraph,
	              backgroundColor = Math.floor(Math.random() * 254 + 1),
	              rotation = Math.floor(Math.random() * 65 + 15);
	          return _react2.default.createElement(
	            'li',
	            { key: post.node.id },
	            _react2.default.createElement(
	              'figure',
	              { className: 'backgroundImage', style: { backgroundImage: 'url(' + image } },
	              _react2.default.createElement('span', { style: { background: 'hsl(' + backgroundColor + ', 100%, 30%)', color: 'pink', transform: 'rotate(' + rotation + 'deg)' } })
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  ' ',
	                  title,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  ' ',
	                  description,
	                  ' '
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                firstParagraph
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'more' },
	                draft ? _react2.default.createElement(
	                  'span',
	                  { style: { fontStyle: 'italic', color: '#cecece' } },
	                  'Coming Soon'
	                ) : _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { 'data-hover': 'Read More', to: path },
	                  'Read More'
	                )
	              )
	            )
	          );
	        })
	      )
	    );
	  };
	
	  return BlogBlock;
	}(_react2.default.Component);
	
	exports.default = BlogBlock;
	module.exports = exports['default'];

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _path = __webpack_require__(23);
	
	var _path2 = _interopRequireDefault(_path);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Header.prototype.scrollTo = function scrollTo(ev, element) {
	    var redirect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	    if (redirect) {
	      ev.preventDefault();
	    }
	    var elementNode = document.getElementById(element);
	
	    window.scrollTo(0, elementNode.offsetTop);
	  };
	
	  Header.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { style: { marginBottom: '1.45rem' } },
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            opacity: 0.8,
	            zIndex: 999,
	            top: 0,
	            width: '100%',
	            position: 'fixed',
	            margin: '0 auto',
	            padding: '1rem 0',
	            textAlign: 'center',
	            background: '#eee'
	          } },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/', onClick: function onClick(ev) {
	              return _this2.scrollTo(ev, 'Top', false);
	            }, 'data-hover': 'Home', style: { margin: '0 1em' } },
	          'Home'
	        ),
	        _react2.default.createElement(
	          'a',
	          { 'data-hover': 'Resume', onClick: function onClick(ev) {
	              return _this2.scrollTo(ev, 'Resume');
	            }, style: { margin: '0 1em' } },
	          'Resume'
	        ),
	        _react2.default.createElement(
	          'a',
	          { 'data-hover': 'Portfolio', onClick: function onClick(ev) {
	              return _this2.scrollTo(ev, 'Work');
	            }, style: { margin: '0 1em' } },
	          'Portfolio'
	        ),
	        _react2.default.createElement(
	          'a',
	          { 'data-hover': 'Blog', onClick: function onClick(ev) {
	              return _this2.scrollTo(ev, 'Blog');
	            }, style: { margin: '0 1em' } },
	          'Blog'
	        )
	      )
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.postQUERY = undefined;
	exports.default = IndexPage;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _welcomeBlock = __webpack_require__(73);
	
	var _welcomeBlock2 = _interopRequireDefault(_welcomeBlock);
	
	var _resumeBlock = __webpack_require__(72);
	
	var _resumeBlock2 = _interopRequireDefault(_resumeBlock);
	
	var _portfolio = __webpack_require__(71);
	
	var _portfolio2 = _interopRequireDefault(_portfolio);
	
	var _blogPosts = __webpack_require__(69);
	
	var _blogPosts2 = _interopRequireDefault(_blogPosts);
	
	var _header = __webpack_require__(70);
	
	var _header2 = _interopRequireDefault(_header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function IndexPage(_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'page-from-left' },
	    _react2.default.createElement(_header2.default, null),
	    _react2.default.createElement(
	      'div',
	      { style: { margin: '-1.1em' } },
	      _react2.default.createElement(_welcomeBlock2.default, null)
	    ),
	    _react2.default.createElement('hr', { style: { marginBottom: '4em' } }),
	    _react2.default.createElement(_resumeBlock2.default, null),
	    _react2.default.createElement('hr', { style: { margin: '0 30% 5em 30%' } }),
	    _react2.default.createElement(_portfolio2.default, { id: 'Work', data: data }),
	    _react2.default.createElement('hr', { style: { margin: '4em 30%' } }),
	    _react2.default.createElement(_blogPosts2.default, { id: 'Blog', data: data })
	  );
	}
	
	var postQUERY = exports.postQUERY = '** extracted graphql fragment **';

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _path = __webpack_require__(23);
	
	var _path2 = _interopRequireDefault(_path);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PortfolioBlock = function (_React$Component) {
	  _inherits(PortfolioBlock, _React$Component);
	
	  function PortfolioBlock() {
	    _classCallCheck(this, PortfolioBlock);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PortfolioBlock.prototype.render = function render() {
	    if (!this.props.data) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        ' no data '
	      );
	    }
	    var data = this.props.data;
	    return _react2.default.createElement(
	      'div',
	      { style: {
	          margin: '0 auto',
	          maxWidth: 1100,
	          padding: '0px 1.0875rem 1.45rem',
	          paddingTop: 0
	        }, id: 'Work' },
	      _react2.default.createElement(
	        'h2',
	        { style: { textAlign: 'center' } },
	        ' Work '
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: 'portfolio', style: { margin: 0 } },
	        data.allMarkdownRemark.edges.filter(function (post) {
	          return post.node.frontmatter.type == "work";
	        }).map(function (post) {
	          var image = post.node.frontmatter.image ? post.node.frontmatter.image.childImageSharp.responsiveSizes.src : '',
	              title = post.node.frontmatter.title,
	              path = post.node.frontmatter.path,
	              description = post.node.frontmatter.description;
	          return _react2.default.createElement(
	            'li',
	            { key: post.node.id },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              {
	                to: path },
	              title,
	              _react2.default.createElement(
	                'span',
	                null,
	                ' ',
	                description,
	                ' '
	              )
	            ),
	            _react2.default.createElement('figure', { className: 'backgroundImage', style: { backgroundImage: 'url(' + image } })
	          );
	        })
	      )
	    );
	  };
	
	  return PortfolioBlock;
	}(_react2.default.Component);
	
	exports.default = PortfolioBlock;
	module.exports = exports['default'];

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _path = __webpack_require__(23);
	
	var _path2 = _interopRequireDefault(_path);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResumeBlock = function (_React$Component) {
	  _inherits(ResumeBlock, _React$Component);
	
	  function ResumeBlock() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ResumeBlock);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.experiance = [{
	      location: 'Bristol',
	      name: 'Wazoku',
	      role: 'Work Placement Developer',
	      description: 'Conducting my work placement/industry year from Plymouth University with Wazoku, a web software company. My role here was to maintain and contribute to development efforts for Idea Spotlight, an idea management web platform. As a developer, I used various technologies, including CSS preprocessors, AngularJs, Grunt, and Django working in a large team using agile methodologies and git flow source control. Also had experience starting a new project on a small 2 person team where I had the control over the architecture and design process working with a backend Django developer.',
	      date: 'September 2015 - September 2016'
	    }, {
	      location: 'Plymouth',
	      name: 'Wazoku, Self Employed',
	      role: 'Contractor',
	      description: 'Working on a contract basis on a new project for Wazoku, consuming their Public API to create a simplified idea management platform for a client. A solo project using Angular2 to provide web and mobile experience and implementing social login through LinkedIn with 0Auth. Experience with architecting developing and deploying the project - used Firebase to create a serverless test site for Wazoku and constructing a simple end to end test suite with selenium.',
	      date: 'November 2016 - March 2017'
	    }, {
	      location: 'Plymouth University',
	      name: 'Creative Summer Studio',
	      role: 'Developer',
	      description: 'Working with the University studio on various projects as a developer. Working with Angular, Firebase and progressive web app technologies to optimise performance of Artory, an existing mobile app. Working on Emoti-OS https://emoti-os.me/ a realtime Wordpress site using sockets to facilitate text communication between users and an AI entity, using CSS Animations to create an interactive experience.',
	      date: 'May 2017 - August 2017'
	    }, {
	      location: 'Bristol',
	      name: 'Wazoku',
	      role: 'Developer',
	      description: 'Rejoining Wazoku as a developer. I have been focusing on producing clean, tested and maintainable code. Using modern JavaScript technologies such as Typescript, WebPack and AngularJs for a large-scale web app and Jasmine, Karma and Selenium for frontend test coverage . I have also attended NG Poland while here, looking into the bennifits of state management in web apps.',
	      date: 'August 2017 - Present'
	    }], _this.education = [{
	      level: 'A-Level',
	      title: 'Photography, Media Studies, and, Information and Communications Technology',
	      name: 'Eggbuckland Community College',
	      date: 'September 2012 - June 2014'
	    }, {
	      level: 'Degree',
	      title: 'BSc Digital Arts and Technology - First Class Honours',
	      name: 'Plymouth University',
	      date: 'September 2014 - July 2017'
	    }], _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ResumeBlock.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { style: {
	          margin: '0 auto',
	          maxWidth: 960,
	          padding: '0px 1.0875rem 1.45rem',
	          paddingTop: 0
	        }, id: 'Resume' },
	      _react2.default.createElement(
	        'div',
	        { style: { marginBottom: '10em' } },
	        _react2.default.createElement(
	          'h2',
	          { style: { textAlign: 'center' } },
	          ' Experiance '
	        ),
	        this.experiance.reverse().map(function (xp, i) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'xp-block', key: i, style: { minHeight: '200px', borderLeft: '2px solid #cecece' } },
	            _react2.default.createElement(
	              'figure',
	              { style: { verticalAlign: 'top', minHeight: '200px', width: '40%', display: 'inline-block' } },
	              _react2.default.createElement(
	                'span',
	                { style: { width: '50px', height: '50px', display: 'inline-block', color: '#eee', borderRadius: '5em', position: 'relative', left: '-25px', background: '#333', padding: '.5em', fontSize: '1.4em' } },
	                _react2.default.createElement('i', { className: 'fa fa-briefcase', 'aria-hidden': 'true' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { display: 'inline-grid' } },
	                _react2.default.createElement(
	                  'span',
	                  { style: { display: 'block' } },
	                  ' ',
	                  xp.date,
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'small',
	                  { style: { display: 'block' } },
	                  ' ',
	                  xp.location,
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { minHeight: '200px', width: '60%', display: 'inline-block', marginBottom: '2em' } },
	              _react2.default.createElement(
	                'span',
	                { style: { display: 'block', fontWeight: 'bold' } },
	                ' ',
	                xp.name,
	                ' '
	              ),
	              _react2.default.createElement(
	                'span',
	                { style: { display: 'block', fontWeight: 100 } },
	                ' ',
	                xp.role,
	                ' '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                ' ',
	                xp.description,
	                ' '
	              )
	            )
	          );
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          { style: { textAlign: 'center' } },
	          ' Education '
	        ),
	        this.education.reverse().map(function (xp, i) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'xp-block', key: i, style: { minHeight: '200px', borderLeft: '2px solid #cecece' } },
	            _react2.default.createElement(
	              'figure',
	              { style: { verticalAlign: 'top', width: '40%', display: 'inline-block' } },
	              _react2.default.createElement(
	                'span',
	                { style: { width: '50px', height: '50px', display: 'inline-block', color: '#eee', borderRadius: '5em', position: 'relative', left: '-25px', background: '#333', padding: '.5em', fontSize: '1.4em' } },
	                _react2.default.createElement('i', { className: 'fa fa-briefcase', 'aria-hidden': 'true' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { display: 'inline-grid' } },
	                _react2.default.createElement(
	                  'span',
	                  { style: { display: 'block' } },
	                  ' ',
	                  xp.date,
	                  ' '
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { width: '60%', display: 'inline-block', marginBottom: '2em' } },
	              _react2.default.createElement(
	                'span',
	                { style: { display: 'block', fontWeight: 'bold' } },
	                ' ',
	                xp.level,
	                ' '
	              ),
	              _react2.default.createElement(
	                'span',
	                { style: { display: 'block', fontWeight: 100 } },
	                ' ',
	                xp.name,
	                ' '
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                ' ',
	                xp.title,
	                ' '
	              )
	            )
	          );
	        })
	      )
	    );
	  };
	
	  return ResumeBlock;
	}(_react2.default.Component);
	
	exports.default = ResumeBlock;
	module.exports = exports['default'];

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/1741811.b08acb94.jpg";

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/home-intro-high.9a7a7053.jpg";

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/home-intro-low.c271642f.jpg";

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _homeIntroHigh = __webpack_require__(125);
	
	var _homeIntroHigh2 = _interopRequireDefault(_homeIntroHigh);
	
	var _homeIntroLow = __webpack_require__(126);
	
	var _homeIntroLow2 = _interopRequireDefault(_homeIntroLow);
	
	var _ = __webpack_require__(124);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WelcomeBlock = function (_React$Component) {
	  _inherits(WelcomeBlock, _React$Component);
	
	  function WelcomeBlock() {
	    _classCallCheck(this, WelcomeBlock);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  WelcomeBlock.prototype.render = function render() {
	    var _ref;
	
	    return _react2.default.createElement(
	      "div",
	      { id: "Top", style: { paddingTop: '62px' } },
	      _react2.default.createElement("div", { className: "responsive-half", style: { minHeight: '500px', display: 'inline-block', verticalAlign: 'top', backgroundImage: "url(" + _homeIntroHigh2.default + ")", backgroundSize: 'cover', backgroundPosition: 'center center' } }),
	      _react2.default.createElement(
	        "div",
	        { className: "responsive-half", style: { display: 'inline-block', verticalAlign: 'top' } },
	        _react2.default.createElement(
	          "div",
	          { style: { height: '350px', background: '#eee', padding: '2em' } },
	          _react2.default.createElement(
	            "div",
	            { style: { marginBottom: '1em' } },
	            _react2.default.createElement(
	              "h1",
	              { style: { margin: '5px' } },
	              " JOSH JARVIS"
	            ),
	            _react2.default.createElement(
	              "small",
	              { style: { color: '#999' } },
	              " Digital Artist | Developer "
	            )
	          ),
	          _react2.default.createElement(
	            "h4",
	            { style: { fontSize: '2em', maxWidth: '15em', textAlign: 'left' } },
	            " A creative Web Developer and Digital Artist based in the South West."
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: (_ref = { height: '150px', padding: '1em', color: '#eee', background: '#333' }, _ref["padding"] = '3em', _ref) },
	          _react2.default.createElement(
	            "a",
	            { href: "https://www.linkedin.com/in/josh-j/", className: "social-link" },
	            _react2.default.createElement("i", { className: "fa fa-linkedin", "aria-hidden": "true" })
	          ),
	          _react2.default.createElement(
	            "a",
	            { href: "https://twitter.com/_joshjarvis", className: "social-link" },
	            _react2.default.createElement("i", { className: "fa fa-twitter", "aria-hidden": "true" })
	          ),
	          _react2.default.createElement(
	            "a",
	            { href: "https://github.com/joshJarr", className: "social-link" },
	            _react2.default.createElement("i", { className: "fa fa-github", "aria-hidden": "true" })
	          )
	        )
	      )
	    );
	  };
	
	  return WelcomeBlock;
	}(_react2.default.Component);
	
	exports.default = WelcomeBlock;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-91f4c5a9286d4ec191ea.js